import apiClient from '../apiClient';
import { DELETE_REGION_URL } from '../apiUrl';

const deleteRegionApi = Id => {
  return apiClient.delete(DELETE_REGION_URL(Id));
};

export default deleteRegionApi;
